const Tags = {
  path: "/tags",
  isSection: true,
  sub: {
    one: "/:code",
    list: "/list",
  },
};

export default Tags;
